import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import { CeOffersState, StoreKeys, initialState } from './ceOffersStore';

const store = (set) => ({
  ...initialState,
  [StoreKeys.SET_CE_OFFERS_DATA]: (ceOffersData) =>
    set(() => ({ ceOffersData })),
  [StoreKeys.CLEAR_CE_OFFERS_DATA]: () => set(() => ({ ceOffersData: [] })),
  [StoreKeys.SET_PROGRAM_PROMOTIONS_FOR_RESULT_PAGE]: (
    programPromotionsForResultPage
  ) => set(() => ({ programPromotionsForResultPage })),
});

const mapStore = persist(store, {
  name: 'ceOffersStore',
  storage: createJSONStorage(() => sessionStorage),
  merge: (persistedState: CeOffersState, currentState: CeOffersState) => ({
    ...currentState,
    ...persistedState,
  }),
});

export const useCeOffersStore = create(devtools(mapStore));
